import { createSlice } from "@reduxjs/toolkit";
import { fetchDoctorWalletUnifiedTransactionsReducer } from "../../reducer/doctorWallet/fetchDoctorWalletUnifiedTransactionsReducer";

const initialState = {
  data: {
    transactions: [],
    summary: {
      total_earnings: 0,
      currency: "IQD",
      transaction_count: 0,
      category_breakdown: {
        cash: 0,
        wallet: 0,
        card: 0,
      },
    },
    pagination: {
      current_page: 1,
      per_page: 10,
      total_pages: 0,
      total_records: 0,
      has_next_page: false,
      has_previous_page: false,
    },
  },
  isLoading: false,
  error: null,
  lastFetchParams: null,
};

const doctorWalletUnifiedTransactionsSlice = createSlice({
  name: "doctorWalletUnifiedTransactions",
  initialState,
  reducers: {
    clearTransactions: (state) => {
      state.data.transactions = [];
      state.data.summary = initialState.data.summary;
      state.data.pagination = initialState.data.pagination;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        fetchDoctorWalletUnifiedTransactionsReducer.pending,
        (state, action) => {
          state.isLoading = true;
          state.error = null;
          state.lastFetchParams = action.meta.arg;
        },
      )
      .addCase(
        fetchDoctorWalletUnifiedTransactionsReducer.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.data = action.payload;
          state.error = null;
        },
      )
      .addCase(
        fetchDoctorWalletUnifiedTransactionsReducer.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload || action.error.message;
        },
      );
  },
});

export const { clearTransactions, clearError } =
  doctorWalletUnifiedTransactionsSlice.actions;
export default doctorWalletUnifiedTransactionsSlice.reducer;
